import React from "react";


const controlloDiGestione = () => {

return(<div>Controllo di Gestione</div>)

}

export default controlloDiGestione;